module.exports = __webpack_public_path__ + "img/image5.347d6aa0.jpg";